export enum ProjectStatus {
  SOLD = 'Vendido',
  PAYING_DIVIDENDS = 'Repartiendo dividendos',
  FUNDED = 'Financiado',
  IN_PROGRESS = 'En curso',
  ACTIVE = 'Activo',
  MANAGING_REINVESTMENTS = 'Gestionando reinversiones',
  UNDER_ANALYSIS = 'En estudio',
  UNKNOWN = 'Unknown',
} 